<button
  type="button"
  class="sz-modules-menu__trigger"
  [class.sz-modules-menu__trigger--active]="open()"
  aria-haspopup="menu"
  [attr.aria-label]="'modules.openAria' | translate"
  [attr.aria-expanded]="open()"
  (click)="toggle()">
  <sz-icon name="grid" [size]="18" />
</button>

@if (open()) {
  <div class="sz-modules-menu__backdrop" (click)="close()"></div>
  <div class="sz-modules-menu__panel" role="menu">
    <button type="button" class="sz-modules-menu__item" role="menuitem" (click)="goAmmo()">
      <span class="sz-modules-menu__item-icon">
        <sz-icon name="ammo" [size]="16" />
      </span>
      {{ 'ammo.title' | translate }}
      <span class="sz-modules-menu__arrow">
        <sz-icon name="arrow-right" [size]="14" />
      </span>
    </button>
    <button type="button" class="sz-modules-menu__item sz-modules-menu__item--disabled" role="menuitem" disabled>
      <span class="sz-modules-menu__item-icon">
        <sz-icon name="trophy" [size]="16" />
      </span>
      {{ 'modules.competitions' | translate }}
      <span class="sz-modules-menu__soon">{{ 'modules.soon' | translate }}</span>
    </button>
    <button type="button" class="sz-modules-menu__item sz-modules-menu__item--disabled" role="menuitem" disabled>
      <span class="sz-modules-menu__item-icon">
        <sz-icon name="calculator" [size]="16" />
      </span>
      {{ 'modules.hitFactorCalculator' | translate }}
      <span class="sz-modules-menu__soon">{{ 'modules.soon' | translate }}</span>
    </button>
    <div class="sz-modules-menu__handle" aria-hidden="true"></div>
  </div>
}
